import { useMemo } from "react";
import type {
	ClientRelatedOptionsResponseDTO,
	ClientRelatedOptionsSectionResponseDTO,
} from "web_myplann/Infrastructure/Api/Api";
import type {
	PinCandidate,
	RelatedPinKind,
} from "web_myplann/Portfolio/Components/Redesign/Detail/Pin/pinKind";

const SECTION_BY_KIND: Record<
	RelatedPinKind,
	keyof ClientRelatedOptionsResponseDTO
> = {
	contract: "contracts",
	property: "properties",
	service: "services",
};

export const useRelatedPinCandidates = (
	options: ClientRelatedOptionsResponseDTO | undefined,
	kind: RelatedPinKind,
): PinCandidate[] => {
	const section: ClientRelatedOptionsSectionResponseDTO | null | undefined =
		options?.[SECTION_BY_KIND[kind]];

	return useMemo<PinCandidate[]>(
		() => (section?.items ?? []).map((data) => ({ kind: "related", data })),
		[section?.items],
	);
};
